import { useCallback } from 'react'
import { useGet } from '../../apiHooks'
import { tokenizer } from '../../../services/utils'
import { config } from '../../../components/Init/Init'
import { usePlayerStore } from '../../../services/store'

export const useGetLeaderboardsData = () => {
  const playerStore = usePlayerStore()
  const playerLoginUser = playerStore.use.loginUser()

  const { GET } = useGet()

  const getLeaderboardGames = useCallback(() => {
    const getAvailableLeaderboardsUrl = tokenizer(config.leaderboardApiUrl + config.getAvailableLeaderboardsUrl, {
      '{userId}': playerLoginUser.userId
    })

    return GET(getAvailableLeaderboardsUrl)
      .then(data => data)
      .catch(error => {
        console.log('Failed to fetch available leaderboard by game', error)
        throw error
      })
  }, [GET, playerLoginUser.userId])

  return { getLeaderboardGames }
}
